'use strict';

var _ = require('lodash');
var TrendChartController = function TrendChartController($scope, dataProviderService, $filter) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var tooltipTemplate = _.template(require('../templates/trend-chart-tooltip.html'));
  $scope.legend = [{
    label: 'Spill Pax Gap',
    styleClass: 'm1-legend'
  }, {
    label: 'Recap Pax Gap',
    styleClass: 'm2-legend'
  }];
  $scope.reloadChart = function () {
    var filters = dataProviderService.getFilters($scope.screen, $scope.mode);
    if (_.isUndefined(filters) || _.isUndefined(filters['filter-component'])) {
      return;
    }
    $scope.setLoadingMessage();
    return dataProviderService.getData($scope.screen, $scope.mode, $scope.type).then($scope.renderChart);
  };
  $scope.chartFormatters = {
    xAxis: function xAxis(d) {
      return d.toUpperCase();
    },
    xAxisContainer: function xAxisContainer(d) {
      return rmMomentFormat(d, 'MONTH_DAY');
    },
    tooltipFormatter: function tooltipFormatter(d) {
      return tooltipTemplate({
        dayName: rmMomentFormat(d.d1, 'FULL_DAY_OF_WEEK'),
        date: rmMomentFormat(d.d1, 'DATE_USER_SETTINGS'),
        m1: d.m1,
        m2: d.m2,
        dtd: d.d2,
        isDtD: $scope.type === 'trend-chart-dtd'
      });
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = $scope.type === 'trend-chart-dtd' ? 'rom-analysis-toolbar trend-dtd-chart-tooltip' : 'rom-analysis-toolbar trend-dow-chart-tooltip';
  $scope.$on('brush-filter:filterApplied', $scope.reloadChart);
  $scope.$on('rom-analysis-panel:uncollapseTrendChart', $scope.reloadChart);
};
TrendChartController.$inject = ['$scope', 'TrendChartDataProviderService', '$filter'];
module.exports = TrendChartController;